import { useTranslation } from 'react-i18next';
import type { Currency } from '@worki/shared';
import { currentLocale } from '../../i18n.js';
import { money } from '../../lib/format.js';
import type { ForwardingPreview as Preview } from './model.js';

export function ForwardingPreview({ preview }: { preview: Preview }) {
  const { t } = useTranslation();
  const locale = currentLocale();
  // Income and expenses can share a currency; only the monetary total is combined here.
  const totals = new Map<Currency, number>();
  for (const row of [...preview.pendingSummary.byCurrency, ...preview.pendingSummary.income]) {
    totals.set(row.currency, (totals.get(row.currency) ?? 0) + row.total);
  }
  return <section className="rounded-xl border border-primary/30 p-3 space-y-2" aria-label={t('invoices.forwarding.previewTitle')}>
    <h3 className="font-semibold text-sm">{t('invoices.forwarding.previewTitle')}</h3>
    <p>{t('invoices.forwarding.matchedCount', { count: preview.matchedCount })}</p>
    <p className="font-medium">{t('invoices.forwarding.pendingCount', { count: preview.pendingCount })}</p>
    <p>{t('invoices.forwarding.blockedCount', { count: preview.blockedCount })}</p>
    <ul>{[...totals].map(([currency, total]) => <li key={currency}>{money(total, currency, locale)}</li>)}</ul>
    {preview.pendingSummary.missingAmount > 0 && <p className="text-sm text-muted-foreground">{t('invoices.forwarding.missingTotal', { count: preview.pendingSummary.missingAmount })}</p>}
  </section>;
}
